import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { jobService } from "../../../../services/job-service";
import { empRoute, employer, publicUser } from "../../../../globals/route-names";
import ApplicantDataTable from "../../../common/applicant-data-table";

function EmpCandidatesPage() {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [drafts, setDrafts] = useState({});

    useEffect(() => {
        setLoading(true);
        loadApplications();
    }, []);

    const loadApplications = () => {
        jobService.employerApplications()
            .then((data) => setApplications(data.applications || []))
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    };

    const updateStatus = async (application, status) => {
        setMessage("");
        try {
            await jobService.updateApplication(application.id, { status, employer_note: application.employer_note || "", interview_at: application.interview_at || "" });
            setMessage("Application updated.");
            loadApplications();
        } catch (error) {
            setMessage(error.message);
        }
    };

    const sendMessage = async (application) => {
        const text = (drafts[application.id] || "").trim();
        if (!text) return;
        try {
            await jobService.sendApplicationMessage(application.id, text);
            setDrafts({ ...drafts, [application.id]: "" });
            loadApplications();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Candidate Enquiries</h2>
                <div className="breadcrumbs"><NavLink to={publicUser.HOME1}>Home</NavLink><NavLink to={empRoute(employer.DASHBOARD)}>Dashboard</NavLink><span>Applications</span></div>
            </div>
            <div className="twm-pro-view-chart-wrap">
                <div className="col-lg-12 col-md-12 mb-4">
                    <div className="panel panel-default site-bg-white m-t30">
                        <div className="panel-heading wt-panel-heading p-a20">
                            <h4 className="panel-tittle m-a0"><i className="far fa-list-alt" />Applications Received</h4>
                        </div>
                        <div className="panel-body wt-panel-body">
                            {message && <div className="alert alert-info m-a20">{message}</div>}
                            {loading ? (
                                <div className="p-a30 text-center">Loading enquiries...</div>
                            ) : (
                                <div className="twm-D_table p-a20">
                                    <ApplicantDataTable
                                        applications={applications}
                                        title="Employer Applicants"
                                        emptyText="No candidate enquiries yet. They will appear here when candidates apply to your jobs."
                                        renderActions={(application) => (
                                            <div style={{ minWidth: 260 }}>
                                                <div className="btn-group flex-wrap m-b10">
                                                    {STATUS_ACTIONS.map((item) => <button key={item.status} type="button" className="site-button m-r5 m-b5" onClick={() => updateStatus(application, item.status)}>{item.label}</button>)}
                                                </div>
                                                <textarea className="form-control m-b10" rows={2} placeholder="Message candidate" value={drafts[application.id] || ""} onChange={(event) => setDrafts({ ...drafts, [application.id]: event.target.value })} />
                                                <button type="button" className="site-button-secondry m-b10" onClick={() => sendMessage(application)}>Send Message</button>
                                                {(application.messages || []).map((item) => <div key={item.id} className="small border-top p-t5"><strong>{item.sender_name || item.sender_role}:</strong> {item.message}</div>)}
                                            </div>
                                        )}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const STATUS_ACTIONS = [
    { status: "reviewed", label: "Reviewed" },
    { status: "shortlisted", label: "Shortlist" },
    { status: "interview", label: "Interview" },
    { status: "approved", label: "Approve" },
    { status: "rejected", label: "Reject" },
];

export default EmpCandidatesPage;
